import { DASHBOARD_TYPE } from 'domain/entity/reportTemplate';
import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface CreateDashboardCriteria {
    name: string;
    type: DASHBOARD_TYPE;
}

class CreateDashboardCriteriaImpl implements CreateDashboardCriteria {
    constructor(readonly name: string, readonly type: DASHBOARD_TYPE) {}
}

export class CreateDashboardCriteriaBuilder {
    private name: Option<string> = none;

    private type: DASHBOARD_TYPE = DASHBOARD_TYPE.DASHBOARD;

    static create = (): CreateDashboardCriteriaBuilder => new CreateDashboardCriteriaBuilder();

    withName = (name: string): CreateDashboardCriteriaBuilder => {
        this.name = some(name);
        return this;
    };

    withType = (type: DASHBOARD_TYPE): CreateDashboardCriteriaBuilder => {
        this.type = type;
        return this;
    };

    build = (): CreateDashboardCriteria => {
        if (isNone(this.name)) {
            throw new ReferenceError('Undefined prop');
        }

        return new CreateDashboardCriteriaImpl(this.name.value, this.type);
    };
}
